import { getField, updateField } from 'vuex-map-fields';

export default {
    namespaced: true,

    state: {
        lead: {
            Title: '',
            FirstName: '',
            Surname: '',
            Email: '',
            PhoneDay: '',
            PhoneEvening: '',
            PropertyIdentifier: '',
        },
    },

    getters: {
        getField,
    },

    actions: {
        register({ state }) {
            return axios.post('/api/register', state.lead);
        },
        setPropertyIdentifier(context, value) {
            context.commit('setPropertyIdentifier', value);
        },
    },

    mutations: {
        updateField,
        setPropertyIdentifier(state, value) {
            state.lead.PropertyIdentifier = value;
        },
    },
};
